<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">

  <div class="col-12">

    <h4 class="mb-2 py-1 font-header-1">CFSS Agency</h4>

  </div>
  <div class="col  mb-2">
    <div widget class="card border-0 box-shadow">

      <div class="card-body  widget-body pb-0 pt-2 mb-4">
        <div class="row ">
          <div class="col">
            <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#casemodalopen"
              (click)="CaseCreateupdate('new')" >Add CFSS Agency</button>
          </div>
          <div class="col text-right text-end">
            <button class="btn blue-btn btn-sm" (click)="refresh()">
              <i class="fa fa-repeat"> Refresh </i>
            </button>
          </div>
        </div>
        <!--------------------------------------------ejs-grid-------------------------------------------------------------------------->
        <div class="row mt-2">
          <div class="col mt-2">

            <ejs-grid #grid id="grid" [allowResizing]='true' [dataSource]='data | async' [allowSorting]='true'
              allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage' [filterSettings]='filterOptions'
              (actionBegin)="onActionComplete($event)" (dataStateChange)='dataStateChange($event)'
              [showColumnChooser]='true'>
              <e-columns>
                <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                  [showInColumnChooser]='false'>
                  <ng-template #template let-data>
                    <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#casemodalopen"
                      (click)="editsupport(data);CaseCreateupdate('edit')" ><i
                        class="fa fa-edit"></i></button>&nbsp;
                    <!-- <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#deletemodal"  (click)="setDeleteId(data.id)"><i
                        class="fa fa-trash"></i></button> -->
                  </ng-template>

                </e-column>
                <e-column minWidth=100 field="name" headerText="Name" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="street" headerText="Street" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="city" headerText="City" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="state" headerText="State" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="email" headerText="Email" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>

                <e-column minWidth=100 field="phone" headerText="Phone" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="fax" headerText="Fax" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="zip" headerText="Zip" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <!--------------------------------table header icon---------------->
                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div>
                      <span id='show'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>






<!-- ////////////////////////////////Create and Update model/////////////////////////////////// -->
<span id="opencasemanModal1" data-bs-target="#casemodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="casemodalopen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ModelType =='new'">Create CFSS Agency
           </h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ModelType =='edit'">Update CFSS Agency
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Name<sup class="super-script">*</sup>
                </label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="cfssSupport.name" />
              </div>
            </div>

          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Street</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="cfssSupport.street">
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>City
                </label>
              </div>
              <div class="col-lg-7 pt-2">
                <input type="text" class="form-control" [(ngModel)]="cfssSupport.city" />
              </div>
            </div>

          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>State</label>
              </div>
              <div class="col-lg-7 pt-2">
                <ng-select [(ngModel)]="cfssSupport.state" [items]="stateList" class="width25" [searchable]="true"
                  [clearable]="true" bindLabel="name" bindValue="abbreviation">
                </ng-select>
              </div>
            </div>
          </div>

        </div>

        <div class="row mt-1">
          <div class="col-lg-6">
            <div class="row" [formGroup]="form">
              <div class="col-lg-5">
                <label>Zip</label>
              </div>
              <div class="col-lg-7">
                <input class="form-control" formControlName="zip" [(ngModel)]="cfssSupport.zip" maxlength="8" minlength="5"
                  (keypress)="numberOnly($event)" />
                <div class="error" *ngIf="zip.touched && zip.invalid"> Enter Valid five digit number</div>

              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row" [formGroup]="form">
              <div class="col-lg-5">
                <label>Email</label>
              </div>
              <div class="col-lg-7">
                <input class="form-control" formControlName="email" [(ngModel)]="cfssSupport.email" />
                <div class="error" *ngIf="email.touched && email.invalid"> Enter Valid Mail</div>

              </div>
            </div>
          </div>

        </div>

        <div class="row mt-1">
          <div class="col-lg-6">
            <div class="row" [formGroup]="form">
              <div class="col-lg-5">
                <label>Phone</label>
              </div>
              <div class="col-lg-7">
                <input type="text" [(ngModel)]="cfssSupport.phone" formControlName="phone" minlength="14" maxlength="14"
                  class="form-control" (ngModelChange)="PhoneFormat('phone')" (keypress)="keyPress($event)">
                <span class="error" *ngIf="phone.touched && phone.invalid">Enter Valid number </span>
              </div>
            </div>
          </div>
           <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Languages</label>
              </div>
              <div class="col-lg-7">
                <ng-select [(ngModel)]="cfssSupport.languageLid" [multiple]="true" [items]="languageList" class="width25" [searchable]="true"
                  [clearable]="true" bindLabel="lovName" bindValue="id">
                </ng-select>
              </div>
            </div>
          </div>
        </div>


        <div class="row mt-1">
          <div class="col-lg-6">
           
            <div class="row" [formGroup]="form">
              <div class="col-lg-5">
                <label>Fax</label>
              </div>
              <div class="col-lg-7">
                <input type="text" minlength="14" maxlength="14" class="form-control" formControlName="fax"
                  [(ngModel)]="cfssSupport.fax" (ngModelChange)="PhoneFormat1('fax')" (keypress)="numberOnly($event)" />
                <span class="error" *ngIf="fax.touched && fax.invalid">Enter Valid number </span>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer">

        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='new'" (click)="add('new')"
          [disabled]="isSaveorUpdateBoolean || form.invalid || (cfssSupport.name=='' || cfssSupport.name==undefined)"> Save & Close </button>

        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='edit'" (click)="add('edit')"
          [disabled]="isSaveorUpdateBoolean || form.invalid || (cfssSupport.name=='' || cfssSupport.name==undefined )"> Update & Close </button>

        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Delete</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- =========================================close without save modal======================================================== -->
<span id="cancelcasemanmodal" data-bs-toggle="modal" data-bs-target="#ClosecasemanModal"></span>
<div class="modal fade primarymodal modalbackgrod" id="ClosecasemanModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>